import { Avatar, Badge, Icon, List, Message, Overlay } from '@alifd/next';
import { history } from 'ice';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { receivedNewMessage } from '@/redux/slices/userSlice';

import ezconImg from '../../../../../public/ezcon.png';
import Ic_notifiction from '../../../../../public/icon/ic_notifiction.svg';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Popup } = Overlay;
// const defaultNoticeList = [
//   {
//     id: 1,
//     name: 'Aric',
//     avatar: 'https://img.alicdn.com/tfs/TB1.ZBecq67gK0jSZFHXXa9jVXa-904-826.png',
//     message: '如何查詢包裹？',
//   },
//   {
//     id: 2,
//     name: 'Mark',
//     avatar: 'https://img.alicdn.com/tfs/TB1.ZBecq67gK0jSZFHXXa9jVXa-904-826.png',
//     message: '如何查看新增頁面',
//   },
// ];

const Notice = () => {
  const message = client.service('message');
  const [messageArr, setMessageArr] = useState([]);
  const [badgeCount, setBageCount] = useState();
  const [readList, setReadList] = useState([]);
  const [userId, setUserId] = useState('');
  const hasNewMessage = useSelector((state) => state.user.hasNewMessage);
  const dispatch = useDispatch();

  // console.log(messageArr.length)

  useEffect(() => {
    client
      .reAuthenticate()
      .then((data) => {
        console.log('==relogin ok', data.user);
        setUserId(data.user._id);

        message
          .find({
            query: {
              userId: data.user._id,
              readed: false,
              $sort: {
                createdTime: -1,
              },
            },
          })
          .then((res) => {
            console.log('==find messags success:', res.data);
            setMessageArr(res.data);
            setBageCount(res.data.length);
          })
          .catch((err) => {
            console.log('==find messags fail:', err);
          });
      })
      .catch((err) => {
        console.log('==relogin fail');
        // history.push('/user/login');
      });
    dispatch(receivedNewMessage());
  }, [message, hasNewMessage]);

  function markAsRead(_id) {
    message
      .patch(_id, { readed: true })
      .then((res) => {
        console.log('==messags update  readed=true success:', res);
        setReadList([...readList, _id]);
        setBageCount(badgeCount - 1);
      })
      .catch((err) => {
        console.log('==messags update  readed=true fail:', err);
      });
  }

  function clearNotice() {
    message
      .patch(null, { readed: true }, { query: { userId, readed: false } })
      .then((res) => {
        console.log('==messags update  all readed=true success:', res);
        const noticeIds = messageArr.map((item) => item._id);
        setBageCount(0);
        setReadList(noticeIds);
      })
      .catch((err) => {
        console.log('==messags update  all readed=true fail:', err);
      });
  }

  function viewMore() {
    history.push('/ezpro/noticeRecord');
  }

  const renderList = messageArr.filter(
    (item) => readList.indexOf(item._id) === -1
  );
  // console.log(renderList)
  return (
    <Popup
      trigger={
        <div className={styles.noticeIcon}>
          <Badge dot={badgeCount > 0 ? true : false}>
            <Icon type="email" />
            {/* {
              history.location.pathname === '/mobile/home' ?
                <img  src={Ic_notifiction} alt="Ic_notifiction icon" /> :

                <Icon type="email" />
            } */}
          </Badge>
        </div>
      }
      triggerType="click"
    >
      <List
        size="small"
        divider={false}
        className={styles.noticeContainer}
        header={
          <div className={styles.title}>
            <h4>通知</h4>

            <div className={styles.clearBox}>
              <span className={styles.record} onClick={viewMore}>
                查看紀錄
              </span>
              <span className={styles.clear} onClick={clearNotice}>
                全部已讀
              </span>
            </div>
          </div>
        }
        // footer={
        //   <div className={styles.footer}>
        //     <a onClick={viewMore}>查看更多</a>
        //   </div>
        // }
      >
        {renderList.map((noticeItem) => {
          const { _id, title, content, redirect } = noticeItem;

          return (
            <List.Item
              className={styles.noticeItem}
              key={_id}
              title={title}
              media={<Avatar size={32} src={ezconImg} alt="avatar" />}
              extra={
                <>
                  <span
                    className={styles.close}
                    onClick={() => markAsRead(_id)}
                  >
                    <Icon type="close" size="xs" />
                  </span>
                </>
              }
            >
              <a
                onClick={() => {
                  history.push(redirect);
                }}
              >
                {content}
              </a>
            </List.Item>
          );
        })}
        {renderList.length === 0 && (
          <List.Item className={styles.empty}>你已查看所有通知</List.Item>
        )}
      </List>
    </Popup>
  );
};

// Notice.defaultProps = {
//   noticeList: defaultNoticeList,
// };
export default Notice;
